import { render } from "./TinymceModulesDemo.vue?vue&type=template&id=35bcd5c6&scoped=true"
import script from "./TinymceModulesDemo.vue?vue&type=script&lang=ts"
export * from "./TinymceModulesDemo.vue?vue&type=script&lang=ts"

import "./TinymceModulesDemo.vue?vue&type=style&index=0&id=35bcd5c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35bcd5c6"

export default script